<template>
  <div id="contents" class="service-intro">
    <div class="inner">
      <h3 class="main-title">서비스소개</h3>
      <ul class="tab-wrap">
        <li><a href="/service/hometown" class="tab-btn">SKB 우리동네광고</a></li>
        <li><a href="/service/skylife" class="tab-btn">KT스카이라이프 IPTV광고</a></li>
        <li><a href="/service/experience" class="tab-btn">체험단 마케팅</a></li>
        <li><a href="/service/reporter" class="tab-btn active">기자단 마케팅</a></li>
        <li><a href="/service/insta" class="tab-btn">인스타 마케팅</a></li>
        <li><a href="/service/viral" class="tab-btn">바이럴 마케팅</a></li>
      </ul>
    </div>
    <div class="service-intro-wrap">
      <section class="sec01">
        <div class="inner flexbox center">
          <div class="title-wrap">
            <h4 class="section-title">배포형 블로그 리뷰의 마케팅 기대효과</h4>
            <p class="section-desc">상위노출 한 건의 키워드보장 상품과 달리 건바이건으로 여러가지 글을 작성하여<br>
              리뷰수에 초점을 두어 진행하는 배포 형식의 블로그리뷰 상품입니다. </p>
          </div>
        </div>
      </section>
      <section class="sec02">
        <div class="inner">
          <ul class="list type-btn dir-col">
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro08.png" alt=""/>
                  다양한 게시글로&nbsp;<span class="tx-blue">소비자 호감도 상승</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro13.png" alt=""/>
                  매장의&nbsp;<span class="tx-blue">최신화 정보 전달</span>
                </span>
            </li>
            <li>
                <span class="round-box">
                  <img src="../resource/images/ico_service_intro06.png" alt=""/>
                  최신글 작성으로&nbsp;<span class="tx-blue">업체 신뢰도 UP</span>
                </span>
            </li>
          </ul>
        </div>
      </section>
      <section class="sec04">
        <div class="inner small">
          <h4 class="section-sub-title">매장만의 니즈를 파악하고 의견을 우선시 하여<br>
            방향성에 맞게 시나리오를 작성합니다</h4>
          <div class="flexbox center">
            <img src="../resource/images/service_experience-marketing03.png" alt=""/>
            <ul class="info-list-line">

              <li>
                <h4 class="info-title">플레이스 리뷰 누적 가능</h4>
                <p class="section-desc">플레이스 리뷰창 및 휴대폰에서 검색 노출 가능</p>
              </li>
              <li>
                <h4 class="info-title">호감도 상승효과</h4>
                <p class="section-desc">게시글을 통한 소비자의 호감도 상승</p>
              </li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>

export default {
  name: 'page-notice',
  components: {

  },
  mounted() {
    if (document.body.clientWidth < 800) {
      this.curWidth = 1
    }
    document.body.classList.add('sub');
    this.scroll();
  },
  data () {
    return {
      curWidth: 2.5
    }
  },
  methods: {
    scroll() {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || window.screenY;
      document.querySelectorAll("section").forEach(item => {
        if(scrollTop > item.offsetTop - window.innerHeight / this.curWidth){
          item.classList.add("on");
        }
      });
      window.requestAnimationFrame(this.scroll);
    }
  }
}

</script>